export default "https://a.travel-assets.com/partner-portal/phone.7d21001dad8d.svg";